let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l6Qbn")).then(() => parcelRequire('4Ko8J'));